import React, { useEffect, useState, useContext } from 'react'
import api from '../../services/api'
import { DashboardsContext } from '../../context/dashboards'
const SelectType = ({ onChange, page, select, type, client }) => {
    const [valueOption, setValueOption] = useState("selecione")
    const [dataOptions, setDataOptions] = useState([])

    const getLocation = async () => {
        try {
            const response = await api.get(`/countage/by/client/location/${select}`)
            const uniqueData = response.data.filter(
                (item, index, self) => index === self.findIndex((i) => i.location === item.location)
            );

            setDataOptions(uniqueData);
        } catch (error) {

        }
    }

    useEffect(() => {
        setValueOption("selecione")
    }, [select])

    useEffect(() => {
        if (select != "selecione" && type == "location") {
            getLocation()
        }
        console.log(client, select)
    }, [select])

    const styleSelect = {

        width: "185px",
        height: "45px",
        borderRadius: 60,

        background: "white",
        paddingLeft: "12px",
        border: "1px solid #D7D7D7",
        outline: "none"

    }

    return (

        <div style={{ position: "relative", width: "185px" }}>
            <select className="textSelect" onChange={(e) => {
                setValueOption(e.target.value)
                onChange(e.target.value)
            }} value={valueOption} defaultValue={"selecione"} style={styleSelect}>
                <option style={{ fontFamily: "sans-serif" }}>Selecione</option>
                {
                    select != "selecione" && type == "inventory" && select && (
                        <>
                            <option style={{ fontFamily: "sans-serif" }}>Inventário geral</option>
                            <option style={{ fontFamily: "sans-serif" }}>Inventário Cíclico</option>
                            <option style={{ fontFamily: "sans-serif" }}>Inventário Clinico</option>
                            <option style={{ fontFamily: "sans-serif" }}>Inventário Hospital</option>
                            <option style={{ fontFamily: "sans-serif" }}>Inventário Distibuidor</option>
                        </>
                    )
                    ||
                    select != "selecione" && type == "location" && select && (
                        dataOptions?.map(item => {

                            return (
                                <>
                                    <option style={{ fontFamily: "sans-serif" }} value={item.location}>{item.location}</option>
                                </>
                            )
                        })
                    )
                }
            </select>

            <div style={{ position: "absolute", right: 0, top: "9px", right: "19px" }}>
                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.60677 6.61C5.15396 6.61 4.70115 6.40242 4.35831 5.99494L0.140695 0.982178C-0.0468983 0.759218 -0.0468983 0.39018 0.140695 0.16722C0.328288 -0.05574 0.638787 -0.05574 0.826381 0.16722L5.04399 5.17998C5.35449 5.54902 5.85905 5.54902 6.16955 5.17998L10.3872 0.16722C10.5748 -0.05574 10.8853 -0.05574 11.0729 0.16722C11.2604 0.39018 11.2604 0.759218 11.0729 0.982178L6.85524 5.99494C6.5124 6.40242 6.05959 6.61 5.60677 6.61Z" fill="#888888" />
                </svg>

            </div>

        </div >
    )

}

export default SelectType